import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=5fe45ae9&"
import script from "./nft.vue?vue&type=script&lang=js&"
export * from "./nft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports